import { jsx as _jsx } from "react/jsx-runtime";
import { ModeCommentOutlined } from "sprout-ui-icons";
import { useCallback } from "react";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import { useBus } from "sprout-ui-dom/dist/Bus";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { usePostPageEditor } from "../PostPageEditorContext";
const PostPageToolbarItemReply = (props)=>{
    const currentUser = useCurrentUser();
    const { itemId  } = props;
    const { dispatch  } = usePostPageEditor();
    const canComment = !!currentUser;
    const eventBus = useBus();
    const chooseEditorToOpen = useCallback(()=>{
        if (!canComment) {
            eventBus.emit("dialog::auth::open");
            return true;
        }
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: "REPLY_COMMENT",
                editorPosition: itemId,
                variant: getIsLargePointerDevice() ? "desktop" : "mobile"
            }
        });
        return true;
    }, [
        canComment,
        dispatch,
        eventBus,
        itemId
    ]);
    useActionRegistryGlobalHandler("COMMENT", chooseEditorToOpen, {
        /**
     * Required in Chrome, prevent the letter `r` from filling the editor.
     * But since the editor is a `draft-js` editor, it just crash.
     */ preventDefault: !!canComment
    });
    return /*#__PURE__*/ _jsx(PageToolbarItem, {
        onClick: chooseEditorToOpen,
        icon: ModeCommentOutlined,
        keybinding: "R",
        label: "Comment"
    });
};
export default PostPageToolbarItemReply;
